export function formatPercent(value, digits = 0) {
  return `${(Number(value || 0) * 100).toFixed(digits)}%`;
}

export function formatRatio(value, digits = 2) {
  return `${Number(value || 0).toFixed(digits)}x`;
}

export function formatMoney(value, currency = "USD") {
  const number = Number(value || 0);
  const abs = Math.abs(number);
  const sign = number < 0 ? "-" : "";

  const safeCurrency =
    typeof currency === "string" && /^[A-Z]{3}$/.test(currency)
      ? currency
      : "USD";

  const fmt = (amount, digits = 1) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: safeCurrency,
      maximumFractionDigits: digits,
      minimumFractionDigits: digits,
    }).format(amount);

  if (abs >= 1_000_000_000) {
    return `${sign}${fmt(abs / 1_000_000_000)}B`;
  }

  if (abs >= 1_000_000) {
    const millions = abs / 1_000_000;
    const digits = millions < 10 ? 2 : 1;

    return `${sign}${fmt(millions, digits)}M`;
  }

  if (abs >= 1_000) {
    return `${sign}${fmt(abs / 1_000)}K`;
  }

  return `${sign}${fmt(abs, 0)}`;
}

export function formatMoneyFull(
  value,
  currency = "USD",
  digits = 2
) {
  const number = Number(value || 0);

  const safeCurrency =
    typeof currency === "string" && /^[A-Z]{3}$/.test(currency)
      ? currency
      : "USD";

  const safeDigits = Number.isInteger(digits)
    ? Math.max(0, Math.min(digits, 6))
    : 2;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: safeCurrency,
    minimumFractionDigits: safeDigits,
    maximumFractionDigits: safeDigits,
  }).format(number);
}